import React, { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Header from "./Layout/Header/Header";
import Sidebar from "./Layout/Sidebar/Sidebar";
import Footer from "./Layout/Footer/Footer";
import { FIXED_HEADER_HEIGHT } from "../../utils/constant.utils";

const Admin = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    const stored = localStorage.getItem("adminSidebarOpen");
    return stored ? JSON.parse(stored) : true;
  });

  useEffect(() => {
    localStorage.setItem("adminSidebarOpen", JSON.stringify(isSidebarOpen));
  }, [isSidebarOpen]);

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  return (
    <div className="h-[100vdh] w-[100%] overflow-hidden flex">
      <Sidebar isSidebarOpen={isSidebarOpen} />
      <div className="flex flex-col w-full h-full overflow-hidden">
        <Header toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />
        <div style={{ paddingTop: `${FIXED_HEADER_HEIGHT}px` }}>
          <main className="bg-[#F9F7FF] h-[calc(100vh-124px)] overflow-y-auto">
            <Outlet />
          </main>
          <Footer isSidebarOpen={isSidebarOpen} />
        </div>
      </div>
    </div>
  );
};

export default Admin;
